import React from "react";
import styled from "styled-components";

const SignupMessage = styled.div`
  font-size: 1rem;
  font-weight: 900;
  color: #323232;
  text-align: center;
  margin-top: 2rem;
`;

/**
 * "You clicked before unlock" screen. Forces a full browser refresh so the
 * cooldown ref is reset and the page can re-enter the race fairly.
 * Mirrors monolith lines 1294–1322.
 */
export const EnteredEarlyState: React.FC<{ msEarly: number; scheduledTime?: string }> = ({
  msEarly,
}) => (
  <SignupMessage
    style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}
  >
    <div style={{ color: "#ff3b3b", fontWeight: 700, marginBottom: "8px" }}>
      You clicked {msEarly}ms before unlock.
    </div>
    <div style={{ marginBottom: "12px" }}>Early clicks don&apos;t count. Refresh your browser to try again.</div>
    <button
      type="button"
      onClick={() => window.location.reload()}
      style={{
        marginTop: "4px",
        padding: "10px 20px",
        background: "#009f6f",
        color: "white",
        border: "none",
        cursor: "pointer",
        borderRadius: "4px",
        fontWeight: "bold",
      }}
    >
      Refresh
    </button>
  </SignupMessage>
);

export default EnteredEarlyState;
